import { PriceData } from 'pages/priceList';
import { useTranslation } from 'next-i18next';
import InfoBox from './InfoBox';

type Props = {
  priceList: Array<PriceData>;
};

const PriceListSection = ({ priceList }: any) => {
  const { t, i18n } = useTranslation('priceList');
  return (
    <section className='mb-28'>
      <div className='container mx-auto px-4 flex flex-col lg:flex-row lg:items-center'>
        <div className='flex flex-col w-full mb-8 lg:mb-0 lg:mr-20'>
          <div className='flex justify-between mb-10'>
            <h3 className='text-yellow font-semibold text-2xl'>{t('priceList.title')}</h3>
            <h3 className='text-yellow font-semibold text-2xl text-right'>{t('priceList.price')}</h3>
          </div>
          {priceList &&
            priceList.map((priceObject: any) => (
              <div className='flex justify-between mb-6 last:mb-0' key={priceObject.id}>
                <span className='mr-8'>{priceObject.offer}</span>
                <span className='text-right'>{priceObject.price}</span>
              </div>
            ))}
        </div>
        <InfoBox></InfoBox>
      </div>
    </section>
  );
};

export default PriceListSection;
